const { CountUp } = require('countup.js/dist/countUp.js')
import 'owlcarousel/owl-carousel/owl.carousel'

$(document).on("turbolinks:load", function() {
// $(function() {
  "use strict";
  var owl = $('.owl-carousel');
  // https://owlcarousel2.github.io/OwlCarousel2/docs/api-options.html
  owl.owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 1000,
    autoplayHoverPause: true,
    autoWidth: true,
    items: 4,
    margin: '20px',
    nav: true,
    rewind: true,
  });
  setTimeout(function(){
    owl.trigger('play.owl.autoplay',[1000]);
  }, 1500);

  $("#sidebarToggle, #sidebarToggleTop").on("click", function(e) {
    $("body").toggleClass("sidebar-toggled"), $(".sidebar").toggleClass("toggled"), $(".sidebar").hasClass("toggled") && $(".sidebar .collapse").collapse("hide")
  }), $(window).resize(function() {
    $(window).width() < 768 && $(".sidebar .collapse").collapse("hide")
  }), $("body.fixed-nav .sidebar").on("mousewheel DOMMouseScroll wheel", function(e) {
    if ($(window).width() > 768) {
      var l = e.originalEvent,
        t = l.wheelDelta || -l.detail;
      this.scrollTop += 30 * (t < 0 ? 1 : -1), e.preventDefault()
    }
  }), $(document).on("scroll", function() {
    $(this).scrollTop() > 100 ? $(".scroll-to-top").fadeIn() : $(".scroll-to-top").fadeOut()
  }), $(document).on("click", "a.scroll-to-top", function(e) {
    var l = $(this);
    $("html, body").stop().animate({
      scrollTop: $(l.attr("href")).offset().top
    }, 1e3, "easeInOutExpo"), e.preventDefault()
  });

  if ($('.incremental_numbers').length > 0) {
    var interval = setInterval(function () {
      // https://stackoverflow.com/questions/487073/how-to-check-if-element-is-visible-after-scrolling
      var el = $('.incremental_numbers')[0];
      if (!el) {
        clearInterval(interval);
        return;
      }
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      if (rect.top > 0 && rect.bottom < window.innerHeight) {
        $('.incremental_numbers').each(function(){
          var el = $(this);
          var value = parseInt(el.html());
          if (!el.attr('id')) el.attr('id', 'CountUp_' + Math.random());
          console.log("pp", el.attr('id'));
          var countup = new CountUp(el.attr('id'), value);
          countup.start();
        });
        clearInterval(interval);
      }
    }, 250);
  }

  loadGallery(true, 'a.thumbnail');

  //This function disables buttons when needed
  function disableButtons(counter_max, counter_current){
      $('#show-previous-image, #show-next-image').show();
      if(counter_max == counter_current){
          $('#show-next-image').hide();
      } else if (counter_current == 1){
          $('#show-previous-image').hide();
      }
  }

  /**
   *
   * @param setIDs        Sets IDs when DOM is loaded. If using a PHP counter, set to false.
   * @param setClickAttr  Sets the attribute for the click handler.
   */

  function loadGallery(setIDs, setClickAttr){
    var current_image,
        selector,
        counter = 0;

    $('#show-next-image, #show-previous-image').click(function(){
        if($(this).attr('id') == 'show-previous-image'){
            current_image--;
        } else {
            current_image++;
        }

        selector = $('[data-image-id="' + current_image + '"]');
        updateGallery(selector);
    });

    function updateGallery(selector) {
        var $sel = selector;
        current_image = $sel.data('image-id');
        $('#image-gallery-caption').text($sel.data('caption'));
        $('#image-gallery-title').text($sel.data('title'));
        $('#image-gallery-image').attr('src', $sel.data('image'));
        disableButtons(counter, $sel.data('image-id'));
    }

    if(setIDs == true){
        $('[data-image-id]').each(function(){
            counter++;
            $(this).attr('data-image-id',counter);
        });
    }
    $(setClickAttr).on('click',function(){
        updateGallery($(this));
    });
  }
});